import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState, useEffect } from "react";
import { useIntl } from "react-intl";

export default function SummaryTable({
  selectedChart,
  rows,
  outcomesInfo,
}) {
  const intl = useIntl();
  const [chartType, setChartType] = useState("outcome");
  const [chartTranslate, setChartTranslate] = useState(intl.formatMessage({ id: "QC.Outcome" }));

  useEffect(() => {
    var selected = selectedChart.length == 0 ? "outcome" : selectedChart
    setChartType(selected);

    if(selectedChart == "model"){
      setChartTranslate(intl.formatMessage({ id: "QC.Model" }))
    }
    else if(selectedChart == "aspect"){
      setChartTranslate(intl.formatMessage({ id: "QC.Aspect" }))
    }
    else if(selectedChart == "size"){
      setChartTranslate(intl.formatMessage({ id: "QC.Size" }))
    }
  }, [selectedChart]);

  const getTextByValue = (value) => {
    if (selectedChart == "outcome") {
      let found = outcomesInfo.find((x) => x.idAnagOutcome == value);
      if (found == undefined) {
        return value;
      }
      return found.outcome;
    }
    return value;
  };

  return (
    <div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ textTransform: "capitalize" }}>
                {chartTranslate}
              </TableCell>
              <TableCell>{intl.formatMessage({ id: "QC.ItemsCount" })}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length != 0
              ? rows.map((row) => {
                  return (
                    <TableRow
                      key={row.value}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        height: "45px"
                      }}
                    >
                      <TableCell sx={{pt: 0.9, pb: 0.9}}>{getTextByValue(row.value)}</TableCell>
                      <TableCell sx={{pt: 0.9, pb: 0.9}}>{row.renderedQty}</TableCell>
                    </TableRow>
                  );
                })
              : null}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
